import React from "react";
import { Box, FormLabel } from '@mui/material';

export default (props) =>
  <Box mb={2}>
    <FormLabel>
      {props.children}
    </FormLabel>
  </Box>
